import { z } from 'zod';
import { envelope } from './common.js';

export const HealthResponse = envelope(
  z.object({
    status: z.enum(['ok', 'degraded']),
    db: z.enum(['ok', 'down']),
    version: z.string(),
  }),
);
export type HealthResponse = z.infer<typeof HealthResponse>;
